import React, { useCallback, useState } from "react";
import { GestureResponderEvent, ScrollView, StyleSheet, TouchableOpacity, View } from "react-native";
import { Menu } from "react-native-paper";

import CustomText from "../../../components/common/general/CustomText/CustomText";
import Pill from "../../../components/common/Pill/Pill";
import { NewCustomActionButton } from "../../../components/common/general/CustomButton/NewCustomActionButton";
import { ArrowSquareOut } from "@phosphor-icons/react";

interface Student {
  id: string;
  name: string;
  email: string;
  status?: string | null;
  dateEnrolled?: string;
}

interface StudentProfileTableProps {
  students: Student[];
  onStudentSelect: (studentId: string) => void;
}

// type MenuState = {
//   visible: boolean;
//   x: number;
//   y: number;
//   studentId: string;
//   studentName: string;
// };

const StudentProfileTable: React.FC<StudentProfileTableProps> = ({ students, onStudentSelect }) => {
  // const [menuState, setMenuState] = useState<MenuState>({
  //   visible: false,
  //   x: 0,
  //   y: 0,
  //   studentId: null,
  //   studentName: null,
  // });

  // const handleOpenMenu = useCallback((event: GestureResponderEvent, student: Student) => {
  //   const { pageX, pageY } = event.nativeEvent;

  //   setMenuState({
  //     visible: true,
  //     x: pageX - 100,
  //     y: pageY,
  //     studentId: student.id,
  //     studentName: student.name,
  //   });
  // }, []);

  // const handleCloseMenu = useCallback(() => {
  //   setMenuState({
  //     visible: false,
  //     studentId: null,
  //     studentName: null,
  //     x: 0,
  //     y: 0,
  //   });
  // }, []);

  const handleViewStudent = (studentId: string) => {
    // handleCloseMenu();
    onStudentSelect(studentId);
  };

  const getStudentStatusPill = (student: Student) => {
    if (student.status === "ENROLLED") {
      return { text: "ENROLLED", backgroundColor: "#D1FAE5", textColor: "#065F46" };
    }
    if (student.status === "INVITED") {
      return { text: "INVITED", backgroundColor: "#FEF3C7", textColor: "#92400E" };
    }
    if (student.status === "WITHDRAWN") {
      return { text: "WITHDRAWN", backgroundColor: "#FEE2E2", textColor: "#991B1B" };
    }
    return { text: student.status || "UNKNOWN", backgroundColor: "#F3F4F6", textColor: "#374151" };
  };

  const formatDate = (dateString: string | null) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    } catch {
      return "N/A";
    }
  };

  const getStudentInitial = (name: string) => {
    return name.charAt(0).toUpperCase();
  };

  return (
    <>
      <ScrollView style={styles.tableContainer}>
        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <View style={[styles.cell, styles.studentNameCell]}>
              <CustomText text="Student Name" size="s" weight="medium" style={styles.headerText} />
            </View>
            <View style={[styles.cell, styles.statusCell]}>
              <CustomText text="Status" size="s" weight="medium" style={styles.headerText} />
            </View>
            <View style={[styles.cell, styles.dateEnrolledCell]}>
              <CustomText text="Date Enrolled" size="s" weight="medium" style={styles.headerText} />
            </View>
          </View>

          {students.map((student) => {
            const statusPill = getStudentStatusPill(student);

            return (
              <View key={student.id} style={styles.tableRow}>
                <View style={[styles.cell, styles.studentNameCell]}>
                  <View style={styles.studentNameContent}>
                    <View style={styles.studentAvatar}>
                      <CustomText
                        text={getStudentInitial(student.name)}
                        size="s"
                        weight="bold"
                        style={styles.avatarText}
                        useTranslationText={false}
                      />
                    </View>
                    <View style={styles.studentInfo}>
                      <TouchableOpacity style={styles.studentNameDetails} onPress={() => handleViewStudent(student.id)}>
                        <CustomText
                          text={student.name}
                          weight="medium"
                          style={styles.studentName}
                          useTranslationText={false}
                        />
                        <ArrowSquareOut size={16} color="#3E68FE" />
                      </TouchableOpacity>
                      <CustomText
                        text={student.email}
                        size="xs"
                        style={styles.studentEmail}
                        useTranslationText={false}
                      />
                    </View>
                  </View>
                </View>

                <View style={[styles.cell, styles.statusCell]}>
                  <View style={styles.pillContainer}>
                    <Pill
                      text={statusPill.text}
                      backgroundColor={statusPill.backgroundColor}
                      textColor={statusPill.textColor}
                    />
                  </View>
                </View>

                <View style={[styles.cell, styles.dateEnrolledCell]}>
                  <CustomText
                    text={student.dateEnrolled ? formatDate(student.dateEnrolled) : "N/A"}
                    size="s"
                    style={styles.dateEnrolledText}
                    useTranslationText={false}
                  />
                </View>
              </View>
            );
          })}
        </View>
      </ScrollView>

      {/* <Menu
        visible={menuState.visible}
        onDismiss={handleCloseMenu}
        anchor={{ x: menuState.x, y: menuState.y }}
        contentStyle={styles.menu}> */}
      {/* Not implemented yet */}
      {/* <Menu.Item onPress={() => handleCloseMenu()} title="View Academic Record" titleStyle={styles.menuItemText} />
        <Menu.Item onPress={() => handleCloseMenu()} title="View Submissions" titleStyle={styles.menuItemText} /> */}
      {/* <View style={styles.menuDivider} /> */}
      {/* Not implemented yet */}
      {/* <Menu.Item onPress={() => handleCloseMenu()} title="Send Message" titleStyle={styles.menuItemText} /> */}
      {/* </Menu> */}
    </>
  );
};

const styles = StyleSheet.create({
  tableContainer: {
    flex: 1,
  },
  table: {
    backgroundColor: "#fff",
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#F9FAFB",
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
    paddingVertical: 12,
    paddingHorizontal: 24,
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
    paddingVertical: 16,
    paddingHorizontal: 24,
    minHeight: 72,
  },
  cell: {
    justifyContent: "center",
    paddingHorizontal: 8,
  },
  studentNameCell: {
    flex: 3,
  },
  statusCell: {
    flex: 1.5,
    alignItems: "flex-start",
  },
  dateEnrolledCell: {
    flex: 1.5,
    alignItems: "flex-start",
  },
  headerText: {
    color: "#6B7280",
    fontSize: 12,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  studentNameContent: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  studentInfo: {
    flexDirection: "column",
    gap: 4,
  },
  studentNameDetails: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  studentAvatar: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: "#3E68FE",
    justifyContent: "center",
    alignItems: "center",
  },
  avatarText: {
    color: "#FFFFFF",
    fontSize: 14,
  },
  studentName: {
    color: "#3E68FE",
    fontSize: 15,
    cursor: "pointer",
  },
  studentEmail: {
    color: "#6B7280",
  },
  dateEnrolledText: {
    color: "#6B7280",
  },
  pillContainer: {
    alignSelf: "flex-start",
  },
  // analyticsText: {
  //   color: "#1E293B",
  // },
  // gpaText: {
  //   color: "#1E293B",
  // },
  // creditsText: {
  //   color: "#1E293B",
  // },
  // enrollmentText: {
  //   color: "#6B7280",
  // },
  menu: {
    backgroundColor: "#fff",
    minWidth: 200,
  },
  menuItemText: {
    fontSize: 14,
    color: "#374151",
  },
  menuDivider: {
    height: 1,
    backgroundColor: "#E5E7EB",
    marginVertical: 4,
  },
});

export default StudentProfileTable;
